"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _chevronDown = _interopRequireDefault(require("@spothero/icons/chevron-down"));

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var _Loader = _interopRequireDefault(require("../Loader/Loader"));

// import {
//     SelectItemPropTypes,
//     OptgroupPropTypes
// } from './SelectItemPropTypes';
var Select =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Select, _Component);

  function Select() {
    var _getPrototypeOf2, _context;

    var _this;

    (0, _classCallCheck2.default)(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Select)).call.apply(_getPrototypeOf2, (0, _concat.default)(_context = [this]).call(_context, args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      validationState: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_isFirstRender", true);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onInvalid", function (evt) {
      evt.preventDefault();
      var onInvalid = _this.props.onInvalid;
      var validationState = evt.currentTarget.validity;

      _this.setState({
        validationState: validationState
      });

      if (onInvalid) {
        onInvalid(validationState);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onChange", function (evt) {
      var _context2;

      var _this$props = _this.props,
          items = _this$props.items,
          onChange = _this$props.onChange;
      var selectedItem = (0, _find.default)(_context2 = (0, _reduce.default)(items).call(items, function (options, _ref) {
        var _context3, _context4;

        var optgroup = _ref.optgroup,
            item = (0, _objectWithoutProperties2.default)(_ref, ["optgroup"]);
        return optgroup ? (0, _concat.default)(_context3 = []).call(_context3, (0, _toConsumableArray2.default)(options), (0, _toConsumableArray2.default)(optgroup)) : (0, _concat.default)(_context4 = []).call(_context4, (0, _toConsumableArray2.default)(options), [item]);
      }, [])).call(_context2, function (_ref2) {
        var value = _ref2.value;
        return value === evt.target.value;
      });

      _this.setState({
        validationState: null
      });

      if (onChange) {
        onChange(selectedItem);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderOptgroup", function (_ref3) {
      var label = _ref3.label,
          optgroup = _ref3.optgroup;
      return _react.default.createElement("optgroup", {
        key: label,
        label: label
      }, (0, _map.default)(optgroup).call(optgroup, _this._renderItem));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderItem", function (_ref4, i) {
      var _ref4$disabled = _ref4.disabled,
          disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
          _ref4$label = _ref4.label,
          label = _ref4$label === void 0 ? '' : _ref4$label,
          _ref4$value = _ref4.value,
          value = _ref4$value === void 0 ? '' : _ref4$value;
      return _react.default.createElement("option", {
        key: i,
        value: value,
        disabled: disabled
      }, label);
    });
    return _this;
  }

  (0, _createClass2.default)(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // if a placeholder is present on first render, we want to use this for setting the placeholder class to avoid a flash
      // in the coloring of the placeholder text in the field on initial load
      this._isFirstRender = false;

      this._select.addEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      this._checkIfDisabledSelected();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._select.removeEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "_checkIfDisabledSelected",
    value: function _checkIfDisabledSelected() {
      // if a disabled option is selected at first, make it the same color as placeholder as thats typically why its selected
      if ((0, _isEmpty.default)(this._select.value)) {
        _dom.default.addClass(this._select, 'FormElement-item-placeholder');
      } else {
        _dom.default.removeClass(this._select, 'FormElement-item-placeholder');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          name = _this$props2.name,
          items = _this$props2.items,
          disabled = _this$props2.disabled,
          loading = _this$props2.loading,
          error = _this$props2.error,
          helpNode = _this$props2.helpNode,
          label = _this$props2.label,
          dropdownIcon = _this$props2.dropdownIcon,
          icon = _this$props2.icon,
          iconPosition = _this$props2.iconPosition,
          required = _this$props2.required,
          inline = _this$props2.inline,
          defaultValue = _this$props2.defaultValue,
          placeholder = _this$props2.placeholder,
          onFocus = _this$props2.onFocus;
      var validationState = this.state.validationState;
      var isValid = validationState ? validationState.valid : true;
      var containerClasses = (0, _classnames.default)('Select', 'FormElement', {
        'FormElement-inline': inline
      }, {
        'FormElement-with-icon': icon
      }, (0, _defineProperty2.default)({}, "FormElement-with-icon-".concat(iconPosition), icon), {
        'FormElement-contains-error': !isValid
      }, className);
      var itemClasses = (0, _classnames.default)('FormElement-item', {
        'FormElement-item-placeholder': placeholder && !defaultValue && this._isFirstRender
      });
      var customIconClasses = (0, _classnames.default)('Select-dropdown-icon', dropdownIcon ? dropdownIcon.props.className : null);
      var newDefaultValue = placeholder && !defaultValue ? '' : defaultValue;
      return _react.default.createElement("div", {
        className: containerClasses
      }, label, _react.default.createElement("div", {
        className: "FormElement-control"
      }, _react.default.createElement("select", {
        ref: function ref(node) {
          _this2._select = node;
        },
        className: itemClasses,
        name: name,
        required: required,
        disabled: disabled,
        defaultValue: newDefaultValue,
        onFocus: onFocus,
        onChange: this._onChange
      }, placeholder && _react.default.createElement("option", {
        value: "",
        disabled: true
      }, placeholder), (0, _map.default)(items).call(items, function (item, i) {
        return item.optgroup ? _this2._renderOptgroup(item) : _this2._renderItem(item, i);
      })), loading ? _react.default.createElement(_Loader.default, {
        size: 16,
        borderWidth: 2
      }) : dropdownIcon ? (0, _react.cloneElement)(dropdownIcon, {
        className: customIconClasses
      }) : _react.default.createElement(_chevronDown.default, {
        className: "Select-dropdown-icon"
      }), _react.default.createElement("span", {
        className: "Select-icon"
      }, icon)), helpNode && _react.default.createElement("div", {
        className: "FormElement-help-text"
      }, helpNode), !isValid && error);
    }
  }, {
    key: "node",

    /**
     * Getter for the select DOM element.
     *
     * @public
     * @returns {Element} - The select element.
     */
    get: function get() {
      return this._select;
    }
  }]);
  return Select;
}(_react.Component);

exports.default = Select;
(0, _defineProperty2.default)(Select, "defaultProps", {
  iconPosition: 'left'
});